import { render, staticRenderFns } from "./SearchBoxButton.vue?vue&type=template&id=85e2be84"
import script from "./SearchBoxButton.vue?vue&type=script&lang=js"
export * from "./SearchBoxButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports